/* slbmoto-popup.js - GENERATED by GARAGE popup/storefront.py from popup-render.js + popup-runtime.js. Do not edit here: edit the sources and rebuild. */
(function (root) {
  'use strict';

  var CSS = [
    '.slbp{position:fixed;inset:0;z-index:2147483000;display:flex;',
    ' background:var(--slbp-bg,var(--slbp-paper));color:var(--slbp-ink);',
    ' font-family:var(--font-body-family,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif);',
    ' -webkit-font-smoothing:antialiased;overflow:auto;overscroll-behavior:contain;box-sizing:border-box}',
    '.slbp *{box-sizing:border-box}',
    '.slbp--contained{position:absolute}',
    '.slbp-close{position:absolute;top:14px;right:14px;width:40px;height:40px;',
    ' border:0;background:transparent;color:var(--slbp-ink);font-size:28px;',
    ' line-height:1;cursor:pointer;border-radius:50%;z-index:2}',
    '.slbp-close:focus-visible,.slbp-dismiss:focus-visible,.slbp-btn:focus-visible,',
    ' .slbp-copy:focus-visible{outline:3px solid var(--slbp-button);outline-offset:2px}',
    '.slbp-hero{background-size:cover;background-position:center;flex:none}',
    '.slbp-body{flex:1;display:flex;flex-direction:column;align-items:center;',
    ' justify-content:center;text-align:center;padding:64px 24px 32px}',
    '.slbp-inner{width:100%;max-width:420px}',
    '.slbp-logo{display:block;width:200px;max-width:70%;height:auto;margin:0 auto 22px}',
    '.slbp-h{font-family:var(--font-heading-family,inherit);font-size:32px;line-height:1.1;',
    ' font-weight:800;margin:0 0 12px;color:var(--slbp-ink);',
    ' letter-spacing:-.01em;white-space:pre-line}',
    '.slbp-sub{font-size:17px;line-height:1.45;margin:0 0 22px;white-space:pre-line}',
    '.slbp-form{display:flex;flex-direction:column;gap:10px;margin:0}',
    '.slbp-label{position:absolute;width:1px;height:1px;overflow:hidden;',
    ' clip:rect(0 0 0 0);white-space:nowrap}',
    '.slbp-input{width:100%;font-size:17px;padding:15px 14px;border:1.5px solid var(--slbp-ink);',
    ' border-radius:6px;background:#fff;color:var(--slbp-ink)}',
    '.slbp-btn{width:100%;font-size:19px;font-weight:800;padding:15px 14px;border:0;',
    ' border-radius:6px;background:var(--slbp-button);color:#fff;cursor:pointer}',
    '.slbp-consent{font-size:12px;line-height:1.4;opacity:.75;margin:12px 0 0}',
    '.slbp-answers{display:flex;flex-direction:column;gap:10px;margin:4px 0 0}',
    '.slbp-answer{width:100%;font-size:18px;font-weight:700;padding:14px;border-radius:6px;',
    ' border:2px solid var(--slbp-ink);background:#fff;color:var(--slbp-ink);cursor:pointer}',
    '.slbp-answer:focus-visible{outline:3px solid var(--slbp-button);outline-offset:2px}',
    '.slbp--desktop .slbp-answers{display:grid;grid-template-columns:1fr 1fr}',
    '.slbp-answers--big{gap:14px}',
    '.slbp-answers--big .slbp-answer{font-size:21px;padding:24px 16px}',
    '.slbp--desktop .slbp-answers--3{grid-template-columns:1fr 1fr 1fr}',
    '.slbp-dismiss{display:inline-block;margin-top:18px;font-size:15px;color:var(--slbp-ink);',
    ' background:none;border:0;text-decoration:underline;cursor:pointer;padding:6px}',
    '.slbp-code{display:flex;align-items:center;justify-content:space-between;gap:10px;',
    ' border:2px dashed var(--slbp-ink);border-radius:6px;padding:12px 14px;margin:0 0 16px;',
    ' background:#fff}',
    '.slbp-code b{font-size:22px;letter-spacing:.04em}',
    '.slbp-copy{font-size:14px;font-weight:700;background:none;border:1.5px solid var(--slbp-ink);',
    ' color:var(--slbp-ink);border-radius:4px;padding:6px 10px;cursor:pointer}',
    '.slbp-empty{opacity:.35;font-style:italic}',
    '.slbp-hp{position:absolute;left:-9999px;width:1px;height:1px;opacity:0}',
    '.slbp-err{font-size:14px;color:#b42318;margin:0;min-height:0}',
    '.slbp-err:empty{display:none}',
    '.slbp--mobile{flex-direction:column}',
    '.slbp--mobile .slbp-hero{height:34%;min-height:150px}',
    '.slbp--mobile.slbp--hero .slbp-body{padding-top:24px;justify-content:flex-start}',
    '.slbp--mobile .slbp-h{font-size:30px}',
    '.slbp--desktop{flex-direction:row}',
    '.slbp--desktop .slbp-hero{width:50%}',
    '.slbp--desktop .slbp-inner{max-width:460px}',
    '.slbp--desktop .slbp-h{font-size:44px}',
    '.slbp--desktop .slbp-sub{font-size:19px}'
  ].join('');

  function ensureStyle(doc) {
    if (doc.getElementById('slbp-style')) return;
    var s = doc.createElement('style');
    s.id = 'slbp-style';
    s.appendChild(doc.createTextNode(CSS));
    (doc.head || doc.documentElement).appendChild(s);
  }

  function make(doc, tag, cls, text) {
    var n = doc.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  function copy(doc, tag, cls, variant, field, opts) {
    var text = (variant[field] || '').trim();
    if (!text) {
      if (!opts.preview) return null;
      return make(doc, tag, (cls ? cls + ' ' : '') + 'slbp-empty', '[' + field + ']');
    }
    return make(doc, tag, cls, text);
  }

  function add(parent, child) { if (child) parent.appendChild(child); return child; }

  var HEX = /^#[0-9A-Fa-f]{6}$/;
  function backdrop(variant, brand) {
    var from = variant.background_from, to = variant.background_to;
    if (!HEX.test(from || '')) return brand.paper || '#f5f5f5';
    if (variant.background_type === 'gradient' && HEX.test(to || '')) {
      return 'linear-gradient(to bottom, ' + from + ', ' + to + ')';
    }
    return from;
  }

  function render(host, variant, opts) {
    opts = opts || {};
    var doc = host.ownerDocument;
    ensureStyle(doc);
    while (host.firstChild) host.removeChild(host.firstChild);

    var device = opts.device === 'desktop' ? 'desktop' : 'mobile';
    var step = opts.step === 'success' ? 'success'
      : (opts.step === 'question' && variant.flow === 'question_first') ? 'question' : 'optin';
    var brand = opts.brand || {};
    var hero = !!variant.image_url && (variant.layout === 'hero_both' ||
      (variant.layout === 'hero_desktop' && device === 'desktop'));

    var box = make(doc, 'div', 'slbp slbp--' + device + (hero ? ' slbp--hero' : '') +
      (opts.contained ? ' slbp--contained' : ''));
    box.style.setProperty('--slbp-ink', brand.ink || '#2c3e50');
    box.style.setProperty('--slbp-paper', brand.paper || '#f5f5f5');
    box.style.setProperty('--slbp-button', brand.button || '#ff6600');
    box.style.setProperty('--slbp-bg', backdrop(variant, brand));
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-labelledby', 'slbp-h');

    var close = add(box, make(doc, 'button', 'slbp-close', '×'));
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.setAttribute('data-slbp', 'close');

    if (hero) {
      var img = add(box, make(doc, 'div', 'slbp-hero'));
      img.style.backgroundImage = 'url("' + String(variant.image_url).replace(/"/g, '%22') + '")';
      img.setAttribute('role', 'img');
      img.setAttribute('aria-label', variant.image_alt || '');
    }

    var body = add(box, make(doc, 'div', 'slbp-body'));
    var inner = add(body, make(doc, 'div', 'slbp-inner'));
    if (opts.logoUrl) {
      var logo = add(inner, make(doc, 'img', 'slbp-logo'));
      logo.src = opts.logoUrl;
      logo.alt = 'SLBMoto';
    }

    if (step === 'question') {
      var qh = add(inner, copy(doc, 'h2', 'slbp-h', variant, 'question_text', opts));
      if (qh) qh.id = 'slbp-h';
      var answers = variant.answers || [];
      var list = add(inner, make(doc, 'div', 'slbp-answers' + (answers.length && answers.length <= 3
        ? ' slbp-answers--big slbp-answers--' + answers.length : '')));
      list.setAttribute('role', 'group');
      for (var i = 0; i < answers.length; i++) {
        var b = add(list, make(doc, 'button', 'slbp-answer', answers[i].label || ''));
        b.type = 'button';
        b.setAttribute('data-slbp', 'answer');
        b.setAttribute('data-tag', answers[i].tag || '');
      }
      if (!answers.length && opts.preview) add(list, make(doc, 'p', 'slbp-empty', '[answers]'));
      if (variant.step1_skippable) {
        var skip = add(inner, make(doc, 'button', 'slbp-dismiss', 'Skip'));
        skip.type = 'button';
        skip.setAttribute('data-slbp', 'skip');
      }
    } else if (step === 'optin') {
      var h = add(inner, copy(doc, 'h2', 'slbp-h', variant, 'headline', opts));
      if (h) h.id = 'slbp-h';
      add(inner, copy(doc, 'p', 'slbp-sub', variant, 'subhead', opts));
      var form = add(inner, make(doc, 'form', 'slbp-form'));
      form.setAttribute('novalidate', '');
      form.setAttribute('data-slbp', 'form');
      var label = add(form, make(doc, 'label', 'slbp-label', 'Email address'));
      label.htmlFor = 'slbp-email';
      var input = add(form, make(doc, 'input', 'slbp-input'));
      input.type = 'email';
      input.id = 'slbp-email';
      input.name = 'email';
      input.autocomplete = 'email';
      input.placeholder = 'Your email';
      var hp = add(form, make(doc, 'input', 'slbp-hp'));
      hp.type = 'text';
      hp.name = 'slbp_hp';
      hp.tabIndex = -1;
      hp.autocomplete = 'off';
      hp.setAttribute('aria-hidden', 'true');
      hp.setAttribute('data-slbp', 'hp');
      input.setAttribute('data-slbp', 'email');
      input.setAttribute('aria-describedby', 'slbp-err');
      var err = add(form, make(doc, 'p', 'slbp-err'));
      err.id = 'slbp-err';
      err.setAttribute('role', 'alert');
      err.setAttribute('data-slbp', 'err');
      var btn = add(form, copy(doc, 'button', 'slbp-btn', variant, 'button_text', opts) ||
        make(doc, 'button', 'slbp-btn', ''));
      btn.type = 'submit';
      btn.setAttribute('data-slbp', 'submit');
      add(inner, make(doc, 'p', 'slbp-consent', opts.consentLine || ''));
      var dismiss = add(inner, copy(doc, 'button', 'slbp-dismiss', variant, 'dismiss_text', opts));
      if (dismiss) { dismiss.type = 'button'; dismiss.setAttribute('data-slbp', 'close'); }
    } else {
      var sh = add(inner, copy(doc, 'h2', 'slbp-h', variant, 'success_headline', opts));
      if (sh) sh.id = 'slbp-h';
      if (variant.offer_presentation !== 'code_by_email' && opts.offerCode) {
        var code = add(inner, make(doc, 'div', 'slbp-code'));
        add(code, make(doc, 'b', '', opts.offerCode));
        var cp = add(code, make(doc, 'button', 'slbp-copy', 'Copy'));
        cp.type = 'button';
        cp.setAttribute('data-slbp', 'copy');
        cp.setAttribute('aria-label', 'Copy the code ' + opts.offerCode);
      }
      add(inner, copy(doc, 'p', 'slbp-sub', variant, 'success_body', opts));
      var shop = add(inner, copy(doc, 'button', 'slbp-btn', variant, 'success_button_text', opts));
      if (shop) { shop.type = 'button'; shop.setAttribute('data-slbp', 'shop'); }
    }

    host.appendChild(box);
    return box;
  }

  root.SLBPopup = { render: render, CSS: CSS };
})(typeof window !== 'undefined' ? window : this);
(function () {
  'use strict';
  var W = window, D = document;
  var BUILD = 'slbp-build-f090a3236438';

  function readJSON(id) {
    var el = D.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var CFG = readJSON('slbmoto-popup-config');
  var CTX = readJSON('slbmoto-popup-context') || {};
  if (!CFG || !CFG.enabled || !CFG.arms || !CFG.arms.length || !W.SLBPopup) return;

  function getC(n) {
    var m = D.cookie.match('(?:^|; )' + n + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setC(n, v, days) {
    D.cookie = n + '=' + encodeURIComponent(v) + '; Max-Age=' + Math.round(days * 86400) +
      '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }
  function ss(k, v) {
    try {
      if (v === undefined) return W.sessionStorage.getItem(k);
      if (v === null) W.sessionStorage.removeItem(k); else W.sessionStorage.setItem(k, v);
    } catch (e) { /* private mode: attribution is best-effort */ }
    return null;
  }
  function hex(n) {
    var a = new Uint8Array(n), s = '', i;
    if (W.crypto && W.crypto.getRandomValues) W.crypto.getRandomValues(a);
    else for (i = 0; i < n; i++) a[i] = Math.floor(Math.random() * 256);
    for (i = 0; i < n; i++) s += ('0' + a[i].toString(16)).slice(-2);
    return s;
  }

  var path = location.pathname;
  var query = {};
  location.search.replace(/[?&]([^=&]+)=([^&]*)/g, function (_, k, v) {
    try { query[decodeURIComponent(k)] = decodeURIComponent(v.replace(/\+/g, ' ')); } catch (e) {}
  });
  if (!ss('slbp_lp')) ss('slbp_lp', path);
  if (query.utm_source && !ss('slbp_utm')) ss('slbp_utm', String(query.utm_source).slice(0, 80));
  ss('slbp_pages', String((parseInt(ss('slbp_pages') || '0', 10) || 0) + 1));

  var vid = getC('slbp_id');
  if (!/^[0-9a-f]{32}$/.test(vid || '')) { vid = hex(16); }
  setC('slbp_id', vid, 365);

  var arms = CFG.arms, arm = null, g = getC('slbp_g');
  function byId(id) {
    for (var i = 0; i < arms.length; i++) if (String(arms[i].id) === String(id)) return arms[i];
    return null;
  }
  function pick() {
    var r = Math.random() * 100, acc = 0;
    for (var i = 0; i < arms.length; i++) { acc += arms[i].split; if (r < acc) return arms[i]; }
    return arms[arms.length - 1];
  }
  var dealFor = CFG.test_id ? String(CFG.test_id) : 'd';
  if (g !== 'h') {
    var m = /^v(\d+)(?:\.(\w+))?$/.exec(g || '');
    if (m && (m[2] || 'd') === dealFor) arm = byId(m[1]);
    if (!g && Math.random() * 100 < (CFG.holdout_pct || 0)) g = 'h';
    if (g !== 'h' && !arm) { arm = pick(); }
    if (g !== 'h') g = 'v' + arm.id + '.' + dealFor;
  }
  setC('slbp_g', g, 365);
  var group = g === 'h' ? 'holdout' : 'shown';
  var since = getC('slbp_gd');
  if (!/^\d{4}-\d{2}-\d{2}$/.test(since || '')) since = new Date().toISOString().slice(0, 10);
  setC('slbp_gd', since, 365);

  function dev() {
    var wide = W.matchMedia && W.matchMedia('(min-width: 750px)').matches;
    var coarse = W.matchMedia && W.matchMedia('(pointer: coarse)').matches;
    return wide ? (coarse ? 'tablet' : 'desktop') : 'mobile';
  }
  function send(data) {
    var body = JSON.stringify(data), url = CFG.endpoint + '/popup/i';
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], {type: 'text/plain'}))) return;
    } catch (e) {}
    try {
      fetch(url, {method: 'POST', body: body, keepalive: true, mode: 'cors', credentials: 'omit',
        headers: {'Content-Type': 'text/plain'}}).catch(function () {});
    } catch (e) {}
  }

  var ASSIGN_AFTER_MS = 8000;
  if (!getC('slbp_as')) {
    setTimeout(function () {
      if (getC('slbp_as')) return;
      setC('slbp_as', '1', 365);
      send({k: 'assign', g: group, vid: vid, d: dev(), p: path});
    }, ASSIGN_AFTER_MS);
  }

  function idle(fn) { (W.requestIdleCallback || function (f) { setTimeout(f, 1500); })(fn); }

  if (!ss('slbp_attr') && CFG.cart_attribute && W.fetch) {
    idle(function () {
      var attrs = {}; attrs[CFG.cart_attribute] = group; attrs.slb_popup_since = since;
      fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({attributes: attrs})
      }).then(function (r) { if (r.ok) ss('slbp_attr', '1'); }).catch(function () {});
    });
  }

  if (g === 'h') return;

  if (/^\/(cart|checkout|checkouts|account)(\/|$)/.test(path) || CTX.template === 'cart') return;
  if (CTX.customer && (CTX.ordered || CTX.subscribed)) { setC('slbp_done', '1', 365); return; }

  var v = arm.variant;
  function look() { return dev() === 'mobile' ? 'mobile' : 'desktop'; }
  function attribution() {
    return {utm: ss('slbp_utm') || '', lp: ss('slbp_lp') || path, d: dev()};
  }

  function beacon(kind, extra) {
    var data = {k: kind, v: arm.id, t: CFG.test_id, vid: vid, d: dev(), p: path}, k;
    for (k in (extra || {})) data[k] = extra[k];
    send(data);
  }
  function lead() { try { if (W.fbq) W.fbq('track', 'Lead'); } catch (e) {} }

  var host = null, box = null, lastFocus = null, step = 'optin', chosen = '';

  function focusables() {
    return box ? Array.prototype.filter.call(
      box.querySelectorAll('button, input:not([data-slbp=hp]), a[href]'),
      function (el) { return !el.disabled && el.offsetParent !== null; }) : [];
  }
  function onKey(e) {
    if (!box) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      if (step !== 'success') dismiss('escape'); else close();
    } else if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && D.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && D.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!box.contains(D.activeElement)) { e.preventDefault(); first.focus(); }
    }
  }
  function close() {
    if (host && host.parentNode) host.parentNode.removeChild(host);
    D.removeEventListener('keydown', onKey, true);
    host = box = null;
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  }
  function dismiss(via) {
    beacon('dismiss', {s: step, via: via});
    setC('slbp_dis', '1', v.cap_days || 7);
    close();
  }

  function q(sel) { return box.querySelector('[data-slbp=' + sel + ']'); }

  function render(which, variant) {
    step = which;
    if (!host) {
      lastFocus = D.activeElement;
      host = D.createElement('div');
      host.id = 'slbmoto-popup';
      D.body.appendChild(host);
      D.addEventListener('keydown', onKey, true);
    }
    box = W.SLBPopup.render(host, variant || v, {
      device: look(), step: which, offerCode: CFG.offer_code,
      consentLine: CFG.consent_line, logoUrl: CFG.logo_url, brand: CFG.brand
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-slbp=close]'), function (b) {
      var via = /(^|\s)slbp-close(\s|$)/.test(b.className) ? 'x' : 'link';
      b.addEventListener('click', function () { if (step !== 'success') dismiss(via); else close(); });
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-slbp=answer]'), function (b) {
      b.addEventListener('click', function () {
        chosen = b.getAttribute('data-tag') || '';
        beacon('step', {s: 'answered', a: chosen});
        render('optin');
      });
    });
    var skip = q('skip');
    if (skip) skip.addEventListener('click', function () {
      chosen = '';
      beacon('step', {s: 'skipped'});
      render('optin');
    });
    var form = q('form');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    var cp = q('copy');
    if (cp) cp.addEventListener('click', function () {
      var done = function () { cp.textContent = 'Copied'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(CFG.offer_code).then(done, function () {});
      } else {
        var t = D.createElement('textarea');
        t.value = CFG.offer_code; D.body.appendChild(t); t.select();
        try { D.execCommand('copy'); done(); } catch (e) {}
        D.body.removeChild(t);
      }
    });
    var shop = q('shop');
    if (shop) shop.addEventListener('click', close);
    var first = q('email') || q('answer') || focusables()[0];
    if (first) try { first.focus({preventScroll: true}); } catch (e) { first.focus(); }
  }

  function say(text) { var e = q('err'); if (e) e.textContent = text; }

  var ALREADY_BODY = "You're already in the club, so here's your code.";
  var RESUB_BODY = "Welcome back to the club, so here's your code.";

  function success(reply) {
    setC('slbp_done', '1', 365);
    lead();
    var body = !reply ? '' : reply.already ? ALREADY_BODY : reply.resubscribed ? RESUB_BODY : '';
    if (body && v.offer_presentation === 'code_by_email') {
      var withCode = {}, k;
      for (k in v) withCode[k] = v[k];
      withCode.offer_presentation = 'code_on_screen';
      withCode.success_body = body;
      return render('success', withCode);
    }
    render('success');
  }

  var UNREACHABLE_BODY = 'Enter this code at checkout to get your discount.';

  function unreachable() {
    setC('slbp_dis', '1', v.cap_days || 7);
    var shown = {}, k;
    for (k in v) shown[k] = v[k];
    if (shown.offer_presentation === 'code_by_email') shown.success_body = UNREACHABLE_BODY;
    shown.offer_presentation = 'code_on_screen';
    render('success', shown);
  }

  var RETRY_MS = 15000, pending = null;

  function retryLater(body) {
    pending = body;
    setTimeout(function () {
      if (!pending) return;
      fetch(CFG.endpoint + '/popup/subscribe', {
        method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
        headers: {'Content-Type': 'text/plain'}, body: pending
      }).then(function (r) { if (r.ok) pending = null; }).catch(function () {});
    }, RETRY_MS);
  }
  W.addEventListener('pagehide', function () {
    if (!pending) return;
    try {
      if (navigator.sendBeacon) navigator.sendBeacon(CFG.endpoint + '/popup/subscribe',
        new Blob([pending], {type: 'text/plain'}));
    } catch (e) {}
    pending = null;
  });

  function submit() {
    var input = q('email'), btn = q('submit'), hp = q('hp');
    var email = (input.value || '').trim();
    if (!email || email.indexOf('@') < 1) { say('Enter your email address.'); input.focus(); return; }
    say('');
    btn.disabled = true;
    var a = attribution();
    var payload = {email: email, hp: hp ? hp.value : '', v: arm.id, t: CFG.test_id,
      utm: a.utm, lp: a.lp, d: a.d, vid: vid, sid: hex(16), gd: since};
    if (chosen) payload.a = chosen;
    var body = JSON.stringify(payload);
    var settled = false;
    var ctrl = W.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () {
      if (settled) return; settled = true;
      if (ctrl) ctrl.abort();
      unreachable();
      retryLater(body);
    }, 2000);
    fetch(CFG.endpoint + '/popup/subscribe', {
      method: 'POST', mode: 'cors', credentials: 'omit',
      headers: {'Content-Type': 'text/plain'},
      body: body, signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (b) { return {s: r.status, b: b}; });
    }).then(function (x) {
      if (settled) return; settled = true; clearTimeout(timer);
      if (x.s >= 200 && x.s < 300) return success(x.b);
      if (x.s === 400 && x.b && x.b.field === 'email') {
        btn.disabled = false; say(x.b.error || 'Check your email address.'); input.focus(); return;
      }
      unreachable();
      if (x.s >= 500) retryLater(body);
    }).catch(function () {
      if (settled) return; settled = true; clearTimeout(timer);
      unreachable();
      retryLater(body);
    });
  }

  if (getC('slbp_done') || getC('slbp_dis')) return;

  var SESSION_SECONDS = 30 * 60;
  if (getC('slbp_seen')) { setC('slbp_seen', '1', SESSION_SECONDS / 86400); return; }

  var shown = false;
  function show() {
    if (shown || getC('slbp_done') || getC('slbp_dis') || getC('slbp_seen')) return;
    shown = true;
    setC('slbp_seen', '1', SESSION_SECONDS / 86400);
    render(v.flow === 'question_first' ? 'question' : 'optin');
    beacon('impression', {e: interacted, b: BUILD});
  }

  var interacted = 0;
  ['scroll', 'mousemove', 'touchstart', 'pointerdown', 'keydown'].forEach(function (name) {
    W.addEventListener(name, function () { interacted = 1; }, {passive: true, once: true});
  });

  function start() {
    var t = v.trigger || {}, val = t.value;
    if (t.type === 'pages') {
      if ((parseInt(ss('slbp_pages') || '1', 10) || 1) >= (val || 2)) setTimeout(show, 1000);
    } else if (t.type === 'scroll') {
      var onScroll = function () {
        var h = D.documentElement.scrollHeight - W.innerHeight;
        if (h <= 0 || (W.scrollY / h) * 100 >= (val || 50)) {
          W.removeEventListener('scroll', onScroll); show();
        }
      };
      W.addEventListener('scroll', onScroll, {passive: true});
    } else if (t.type === 'exit_intent') {
      D.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) show();
      });
      var FLICK_PX = 200, FLICK_MS = 400, DEEP_PX = 600;
      var peakY = W.scrollY || 0, peakT = Date.now(), deepest = 0;
      W.addEventListener('scroll', function () {
        var y = W.scrollY || 0, now = Date.now();
        deepest = Math.max(deepest, y);
        if (y >= peakY || now - peakT > FLICK_MS) { peakY = y; peakT = now; }
        else if (deepest > DEEP_PX && peakY - y >= FLICK_PX) show();
      }, {passive: true});
      var wentAway = false;
      D.addEventListener('visibilitychange', function () {
        if (D.visibilityState === 'hidden') wentAway = true;
        else if (wentAway) show();
      });
    } else {
      setTimeout(show, (val || 8) * 1000);
    }
  }

  if (D.readyState === 'complete') start();
  else W.addEventListener('load', start);
})();
